import React, { FC, ReactElement, ChangeEvent, useState } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightForwarder/components/SearchPanel/components/SearchInput/SearchInput.module.scss';

const cn = classNames.bind(styles);

type SearchInput = {
  name: string;
  placeholder: string;
  setSearchValue: (state: any) => void;
  isSearchActive: boolean;
  setIsSearchActive: (state: boolean) => void;
  customStyles?: any;
}

const SearchInput: FC<SearchInput> = ({
  name,
  placeholder,
  setSearchValue,
  setIsSearchActive,
  customStyles
}: SearchInput): ReactElement => {
  const [ inputValue, setInputValue ] = useState<string>('');

  const handleClearValue = () => {
    setInputValue('');
    setSearchValue('');
    setIsSearchActive(false);
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.value === '') handleClearValue();
    setInputValue(event.currentTarget.value);
  };

  const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    if (inputValue === '') {
      handleClearValue();
    } else {
      setSearchValue(inputValue);
      setIsSearchActive(true);
    }
  };

  const handleOnClick = () => {
    if (inputValue === '') {
      handleClearValue();
      setIsSearchActive(false);
    } else {
      setSearchValue(inputValue);
      setIsSearchActive(true);
    }
  };

  return (
    <div
      className={cn('search')}
      style={customStyles ? customStyles.container : {}}
    >
      <input
        className={cn('search__input')}
        type='text'
        name={name}
        value={inputValue ?? ''}
        placeholder={placeholder}
        onChange={handleOnChange}
        onKeyUp={handleOnKeyUp}
      />
      {inputValue && <p className={cn('search__icon-clear')} onClick={handleClearValue}>x</p>}
      <div
        className={cn('search__button')}
        onClick={handleOnClick}
      >
        <img
          className={cn('search__icon-search')}
          src="/images/pages/Resources/FreightForwarder/icon-search.svg"
          alt="search"
        />
      </div>
    </div>
  );
};

export { SearchInput };